import labels from "../../utils/labels";
import { CategoryImpact } from "../../types/constraint";
import StandardButton from "../UI/buttons/StandardButton";
import Modal from "../UI/Modal";
import Overlay from "../UI/Overlay";
import Body2 from "../UI/textFields/Body2";
import Header2 from "../UI/textFields/Header2";

const DeleteCategoryModal = ({
  categoryName,
  impact,
  onDelete,
  onDiscard,
}: {
  categoryName: string;
  impact: CategoryImpact;
  onDelete: () => void;
  onDiscard: () => void;
}) => {
  return (
    <Overlay darkBackground clickAway={onDiscard}>
      <Modal>
        <Header2>{labels.deleteCategoryTitleWithName(categoryName)}</Header2>
        <Body2>{labels.deleteCategoryInUseIntro}</Body2>
        <Body2>
          {labels.deleteCategoryImpactBody(
            impact.employeeCount,
            impact.citizenCount,
          )}
        </Body2>
        <Body2>{labels.deleteCategoryWarningBody}</Body2>
        <div className="flex justify-end gap-[var(--spacing-sm)] w-full">
          <StandardButton
            variant="SECONDARY"
            onClick={onDelete}
            ariaLabel={labels.continue}
          >
            {labels.continue}
          </StandardButton>
          <StandardButton
            variant="PRIMARY"
            onClick={onDiscard}
            ariaLabel={labels.cancel}
          >
            {labels.cancel}
          </StandardButton>
        </div>
      </Modal>
    </Overlay>
  );
};

export default DeleteCategoryModal;
